/**************************************************
 * Nombre:       Tarjeta_Producto_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, ButtonBase, Grid, Typography} from "@mui/material";
import indicador from '../../Recursos/indicador.svg'
import {theme} from "../../Tema";
import {irUrl} from "../../Utilidades/irUrl";
import {useLocation} from "react-router";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {KeyboardArrowLeft, ShoppingCart, TaskAlt} from "@mui/icons-material";
import {obtenerSeccion} from "../../Utilidades/obtenerSeccion";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useFuncionesCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useFuncionesCarritoLateral";
import {useCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useCarritoLateral";
import {useState} from "react";
import {adap_producto_carrito_lateral} from "../../Modulo_Carrito_Lateral/Adaptadores/adap_producto_carrito_lateral";

const Tarjeta_Producto_Detalle = ({item}) => {
    const {sCell, sTab, masSM} = useResponsive()
    const location = useLocation()
    const {adicionarProducto} = useFuncionesCarritoLateral()
    const {Carrito, abrir: abrirCarrito,} = useCarritoLateral()
    const [cargando, setCargando] = useState(false)

    const agregarProducto = (cant) => {
        setCargando(true)

        let prod = adap_producto_carrito_lateral({
            producto: item,
        })
        //Deberia ir aqui el pixel

        /*  window.fbq('track', 'AddToCart', {
              content_ids: [prod.nombre],
              content_type: 'product',
              value: prod.valor,
              currency: 'COP'
          });*/

        adicionarProducto(prod)

        setTimeout(() => {
            abrirCarrito()
            setCargando(false)
        }, 1500)
    }

    return (
        <Grid
            container
            direction="row-reverse"
            justifyContent="flex-start"
            alignItems="center"
            sx={{py: 10, pb: 20}}
            size={12}
        >

            <Carrito/>

            {obtenerSeccion(location.pathname) === 'Detalle' &&
                <Grid item container size={12}
                      sx={{justifyContent: 'flex-start', marginTop: -6, marginBottom: 7}}>
                    <Button
                        onClick={() => window.history.back()}
                        variant={'text'} startIcon={<KeyboardArrowLeft/>}
                        sx={{px: 0, color: '#00000090', marginLeft: masSM ? -6 : 0, py: 0}}
                    >Atras</Button>
                </Grid>
            }


            <Grid item container size={{xs: 12, sm: 5, md: 4}}
                  sx={{justifyContent: 'center', marginTop: sCell ? -2 : 0}}>

                <img src={item.img}
                     width={'100%'} height={'auto'}
                     style={{marginTop: -6}}

                />

            </Grid>

            <Grid item container size={{xs: 12, sm: 7, md: 8}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                >

                    <Grid item container size={12}
                          sx={{justifyContent: 'flex-start', marginLeft: 0, marginTop: sCell ? 4 : 0}}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            size={12}
                        >

                            {item.estado &&
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: -4}}>
                                    <Typography sx={{
                                        backgroundColor: item.estado === 'In Stock' ? theme.palette.primary.main : theme.palette.secondary.main,
                                        px: 2,
                                        borderRadius: 4,
                                        color: '#fff',
                                        pb: 0.3
                                    }}>{item.estado}</Typography>
                                </Grid>
                            }


                            <Grid item container size={11} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{
                                    fontSize: masSM ? 48 : 36,
                                    color: '#124F46',
                                    fontWeight: 700,
                                    textAlign: sCell ? 'center' : 'left',
                                    lineHeight: 1.1,
                                    display: '-webkit-box',
                                    overflow: 'hidden',
                                    WebkitBoxOrient: 'vertical',
                                    WebkitLineClamp: 3,
                                    textOverflow: "ellipsis",
                                }}>
                                    <img src={indicador} width={sTab ? 24 : 30}
                                         height={sTab ? 24 : 30}
                                         style={{marginTop: -8, marginBottom: 8, marginRight: 8}}/>
                                    {item && item.nombre}</Typography>
                            </Grid>
                        </Grid>

                    </Grid>


                    <Grid item container size={{xs: 12, sm: 12, md: 10}}
                          sx={{justifyContent: 'flex-start', marginTop: sCell ? 3 : 2}}>
                        <Typography sx={{
                            fontSize: 18, fontWeight: 400, textAlign: sCell ? 'center' : 'left',
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 4,
                            textOverflow: "ellipsis",
                            px: sCell ? 6 : 0
                        }}>
                            {item && item.descripcion}
                        </Typography>
                    </Grid>

                    <Grid item container size={{xs: 12, sm: 12, md: 9}}
                          sx={{justifyContent: 'flex-start', marginTop: 4}}>
                        {item && item.artesano &&
                            <Typography sx={{fontSize: 18, fontWeight: 400}}>creación de: <span
                            >
                                <ButtonBase
                                    onClick={() => irUrl(`https://www.instagram.com/${item.artesano}/`)}
                                    sx={{
                                        fontWeight: 600,
                                        textDecoration: 'underline',
                                        fontSize: 18
                                    }}
                                >
                                     {`@${item.artesano}`}
                                </ButtonBase>
                               </span></Typography>
                        }
                    </Grid>

                    <Grid item container size={12} sx={{justifyContent: 'flex-start', marginTop: 3}}>
                        {item.valorAntes > 0 &&
                            <Typography sx={{
                                fontSize: 16,
                                fontWeight: 400,
                                color: '#00000090'
                            }}>{`Antes: ${formatoMoneda(item.valorAntes)}`}</Typography>

                        }
                    </Grid>

                    <Grid item container size={12} sx={{justifyContent: 'flex-start', marginTop: -1}}>
                        <Typography sx={{
                            fontSize: 36,
                            fontWeight: 600
                        }}>{item.descuento > 0 ? formatoMoneda(item.rebajado) : formatoMoneda(item.valor)}</Typography>
                    </Grid>

                    <Grid item container size={12} sx={{justifyContent: 'flex-start', marginTop: 4}}>


                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing={2}
                            size={12}>


                            <Button
                                loading={cargando}
                                color={'primary'}
                                disabled={item && item.estado === 'Agotado'}
                                onClick={() => {
                                    agregarProducto(1)

                                }}
                                startIcon={<TaskAlt/>}
                                sx={{px: 6, py: sCell ? 2 : 1, fontSize: 18}} fullWidth={sCell}>
                                Comprar Ahora
                            </Button>


                            <Button
                                color={'info'}
                                loading={cargando}
                                onClick={() => agregarProducto(1)}
                                disabled={item && item.estado === 'Agotado'}
                                startIcon={<ShoppingCart/>}
                                fullWidth={sCell}
                                sx={{color: theme.palette.primary.main, px: 5, py: sCell ? 2 : 1}}>
                                Agregar al Carrito
                            </Button>


                        </Grid>


                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Producto_Detalle    